import { render, staticRenderFns } from "./RIF.vue?vue&type=template&id=5680de90"
import script from "./RIF.vue?vue&type=script&lang=js"
export * from "./RIF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5680de90')) {
      api.createRecord('5680de90', component.options)
    } else {
      api.reload('5680de90', component.options)
    }
    module.hot.accept("./RIF.vue?vue&type=template&id=5680de90", function () {
      api.rerender('5680de90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customer_dashboard/tax_return/components/RIF.vue"
export default component.exports